import { produce } from "immer";
import {
  FETCH_BODYMAP,
  FETCH_BODYMAP_SUCCESS,
  FETCH_BODYMAP_FAILURE,
  //
  GET_VIEW_DATA,
  GET_VIEW_DATA_SUCCESS,
  GET_VIEW_DATA_FAILURE,
  //
  ADD_BODYMAP,
  ADD_BODYMAP_SUCCESS,
  ADD_BODYMAP_FAILURE,
  //
  EDIT_BODYMAP,
  EDIT_BODYMAP_SUCCESS,
  EDIT_BODYMAP_FAILURE,
  //
  DELETE_BODYMAP,
  DELETE_BODYMAP_SUCCESS,
  DELETE_BODYMAP_FAILURE,
} from "./constants";

export const initialState = {
  isFetchingBodyMap: false,
  // Body map feed: { regions: { region: [subjectItem...] }, types: [...], totals }
  bodyMap: {},
  // Add / Edit
  isSubmitting: false,
  // View
  isFetching: false,
  currentTool: {},
  // Delete
  isDeleting: false,
};

const ResidentBodyMapReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      // List
      case FETCH_BODYMAP:
        draft.isFetchingBodyMap = true;
        draft.bodyMap = {};
        break;
      case FETCH_BODYMAP_SUCCESS:
        draft.isFetchingBodyMap = false;
        draft.bodyMap = action.payload || {};
        break;
      case FETCH_BODYMAP_FAILURE:
        draft.bodyMap = {};
        draft.isFetchingBodyMap = false;
        break;
      // View
      case GET_VIEW_DATA:
        draft.isFetching = true;
        draft.currentTool = {};
        break;
      case GET_VIEW_DATA_SUCCESS:
        draft.isFetching = false;
        draft.currentTool = action.payload;
        break;
      case GET_VIEW_DATA_FAILURE:
        draft.isFetching = false;
        break;
      // Add
      case ADD_BODYMAP:
        draft.isSubmitting = true;
        break;
      case ADD_BODYMAP_SUCCESS:
        draft.isSubmitting = false;
        break;
      case ADD_BODYMAP_FAILURE:
        draft.isSubmitting = false;
        break;
      // Edit
      case EDIT_BODYMAP:
        draft.isSubmitting = true;
        break;
      case EDIT_BODYMAP_SUCCESS:
        draft.isSubmitting = false;
        break;
      case EDIT_BODYMAP_FAILURE:
        draft.isSubmitting = false;
        break;
      // Delete
      case DELETE_BODYMAP:
        draft.isDeleting = true;
        break;
      case DELETE_BODYMAP_SUCCESS:
        draft.isDeleting = false;
        break;
      case DELETE_BODYMAP_FAILURE:
        draft.isDeleting = false;
        break;

      default:
        return state;
    }
  });

export default ResidentBodyMapReducer;
